import { render } from "./ZdfHeader.vue?vue&type=template&id=63686586&scoped=true"
import script from "./ZdfHeader.vue?vue&type=script&lang=js"
export * from "./ZdfHeader.vue?vue&type=script&lang=js"

import "./ZdfHeader.vue?vue&type=style&index=0&id=63686586&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63686586"]])

export default __exports__